import React, { useState } from "react";
import { Card } from "react-bootstrap";
import defaultProfilePic from "../assets/defaultProfilePic.png";

const ProfileImage = ({ imageId, setImageError }) => {
  const [altImage, setAltImage] = useState(false);

  const handleImageError = () => {
    if (setImageError) {
      setImageError(true);
    }
    setAltImage(true);
  };

  let folder;
  let renderImage;

  // imageId =
  //   imageId?.toString().length === 4 ? `GymProfilePic/gym${imageId}` : imageId;

  folder =
    imageId?.toString().length === 4
      ? "GymProfilePic"
      : imageId?.substring(0, 4);

  renderImage =
    imageId?.toString().length === 4 ? `gym${imageId}` : imageId?.substring(4);

  return (
    <Card
      style={{
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "10px",
      }}
    >
      {altImage ? (
        <img
          src={defaultProfilePic}
          width={350}
          height={350}
          alt="Profile"
          style={{ borderRadius: "10%" }}
        />
      ) : (
        <img
          src={`https://zpottergym.s3.ap-south-1.amazonaws.com/${folder}/${renderImage}`}
          width={350}
          height={350}
          onError={handleImageError} // Handle image loading error
          alt="Profile"
          style={{ borderRadius: "10%" }}
        />
      )}
    </Card>
  );
};

export default ProfileImage;
